import React from 'react'
import { StyledSearchLink } from './TheWestHeaderActions.styled'
import { SearchForm } from 'component-library/search/SearchForm/SearchForm'
import { StyledSearchIcon } from 'component-library/search/SearchForm/SearchForm.styled'

export const SearchAction: React.FC = () => {
    return (
        <React.Fragment>
            <StyledSearchLink to="/search">
                <StyledSearchIcon />
            </StyledSearchLink>
            <SearchForm inMainNavigation={true} hasPlaceholder={true} />
        </React.Fragment>
    )
}
SearchAction.displayName = 'SearchAction'
